// Backend API base URL, injected at build time from REACT_APP_API_URL
// (see .env.example). No trailing slash.
const apiUrl = process.env.REACT_APP_API_URL;

if (!apiUrl) {
  throw new Error('REACT_APP_API_URL is not set. Copy .env.example to .env.local or set it in the build environment.');
}

export const Baseurl = apiUrl.replace(/\/+$/, '');
